import type { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { useFiltersTheme } from '../../filters-theme-provider';

type FiltersGroupProps = PropsWithChildren<{ title?: string }>;

function FiltersGroupComponent({
  children,
  title,
  ...forwardingProps
}: FiltersGroupProps) {
  const { textColor } = useFiltersTheme();

  return (
    <Container {...forwardingProps}>
      {title && <Title $textColor={textColor}>{title}</Title>}
      {children}
    </Container>
  );
}

export const FiltersGroup = styled(FiltersGroupComponent)``;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Title = styled.div<{ $textColor: string }>`
  text-wrap: balance;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  color: ${({ $textColor }) => $textColor};
`;
